module.exports = __webpack_public_path__ + "static/media/wallpaper.5d3ba9d3.jpg";